import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eb65d5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qr-code" }
const _hoisted_2 = { class: "body-max-width" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-header mt-30" }, "Card number", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-header mt-20" }, "Cardholder name", -1))
const _hoisted_5 = { class: "grid-2" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-header mt-20" }, "Expiry", -1))
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-header mt-20" }, "CVV", -1))
const _hoisted_10 = { class: "flex-center fs-16 fw-500 mt-30" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Set as a default payment", -1))
const _hoisted_12 = { class: "flex-center ml-auto" }
const _hoisted_13 = {
  for: "checkbox",
  class: "lable-checkbox"
}
const _hoisted_14 = { class: "body-max-width-no-padding" }
const _hoisted_15 = { class: "mock-footer relative" }
const _hoisted_16 = { class: "bottom-screen" }
const _hoisted_17 = { class: "footer-menu relative overflow-hidding" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fc-868686 fs-12",
  style: {"line-height":"18px"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, " Your card may be changed to make sure it’s valid. That amount will be automatically refunded. "),
  /*#__PURE__*/_createElementVNode("div", null, "By adding your debit/credit card, you agree to the"),
  /*#__PURE__*/_createElementVNode("div", { style: {"text-decoration":"underline","cursor":"pointer","color":"#000"} }, " Terms & condition ")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-12 mt-4 fs-16 fw-500" }, "Add to Cart", -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, {
        back: "/payment",
        title: "Add card"
      }),
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addCardForm.cardNumber) = $event)),
        class: _normalizeClass(`input-card btn mt-15 ${
          _ctx.addCardFormValidate.cardNumber ? 'validate' : ''
        }`),
        type: "text",
        placeholder: "xxxx-xxxx-xxxx-xxxx",
        inputmode: "decimal"
      }, null, 2), [
        [_vModelText, _ctx.addCardForm.cardNumber]
      ]),
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addCardForm.cardHolderName) = $event)),
        class: _normalizeClass(`input-card btn mt-15 ${
          _ctx.addCardFormValidate.cardHolderName ? 'validate' : ''
        }`),
        placeholder: "xxxx-xxxx-xxxx-xxxx",
        type: "text"
      }, null, 2), [
        [_vModelText, _ctx.addCardForm.cardHolderName]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addCardForm.exriry) = $event)),
            class: _normalizeClass(`input-card btn mt-15 ${
              _ctx.addCardFormValidate.exriry ? 'validate' : ''
            }`),
            placeholder: "MM/YY",
            inputmode: "decimal",
            type: "text"
          }, null, 2), [
            [_vModelText, _ctx.addCardForm.exriry]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addCardForm.cvv) = $event)),
            class: _normalizeClass(`input-card btn mt-15 ${
              _ctx.addCardFormValidate.cvv ? 'validate' : ''
            }`),
            placeholder: "XXX",
            inputmode: "decimal",
            type: "text"
          }, null, 2), [
            [_vModelText, _ctx.addCardForm.cvv]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass(["relative switch-contrainer", { true: _ctx.addCardForm.defaultPayment }])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "checkbox",
              class: "input-checkbox",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addCardForm.defaultPayment) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.addCardForm.defaultPayment]
            ]),
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.addCardForm.defaultPayment), 1)
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveCard && _ctx.saveCard(...args))),
              class: "btn btn-48 btn-primary m-auto",
              style: {"width":"100%","margin-top":"1.8rem"}
            }, _hoisted_20)
          ])
        ])
      ])
    ])
  ]))
}